import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
const tomos = [{
  icon: '📘',
  title: 'Tomo 1 — Física y Química',
  subtitle: 'La Materia y sus Transformaciones',
  desc: 'Propiedades de los materiales, estados de la materia, mezclas y soluciones, cambios físicos y químicos. Con experimentos guiados paso a paso y fichas listas para el aula uruguaya.',
  color: 'bg-blue-50 border-blue-100 text-blue-800'
}, {
  icon: '📗',
  title: 'Tomo 2 — Ciencias de la Tierra',
  subtitle: 'El Planeta que Habitamos',
  desc: 'Las capas de la Tierra, los movimientos terrestres, el Sistema Solar y los recursos naturales de Uruguay. Ciencia real para estudiantes reales del Tramo 2.',
  color: 'bg-emerald-50 border-emerald-100 text-emerald-800'
}, {
  icon: '📙',
  title: 'Tomo 3 — Historia',
  subtitle: 'Las Raíces de lo que Somos',
  desc: 'Desde el tiempo histórico y las fuentes hasta la independencia y Artigas. Pueblos originarios · conquista · colonia. Historia uruguaya contada para ser comprendida, no memorizada.',
  color: 'bg-orange-50 border-orange-100 text-orange-800'
}, {
  icon: '📕',
  title: 'Tomo 4 — Geografía',
  subtitle: 'El Territorio que nos Define',
  desc: 'Puntos cardinales y escala, los 19 departamentos de Uruguay, América Latina y problemáticas ambientales actuales. Geografía que conecta el aula con el mundo real.',
  color: 'bg-red-50 border-red-100 text-red-800'
}, {
  icon: '📓',
  title: 'Tomo 5 — Ciudadanía',
  subtitle: 'Ciudadanos desde el Aula',
  desc: 'Identidad · diversidad · derechos del niño, democracia e instituciones uruguayas y proyecto ciudadano del aula. El tomo que convierte estudiantes en ciudadanos conscientes y activos.',
  color: 'bg-stone-100 border-stone-200 text-stone-800'
}, {
  icon: '📔',
  title: 'Tomo 6 — Evaluaciones y Rúbricas',
  subtitle: 'Sistema de Valoración EBI',
  desc: '24 evaluaciones listas para aplicar, rúbricas por área curricular, fichas de seguimiento individual y registro de logros del Tramo. La escala exacta del EBI: LI · LP · LE · LD.',
  color: 'bg-amber-50 border-amber-100 text-amber-800'
}];
export const TomosGrid = () => {
  return <Section background="cream" data-id="element-368">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-369">
        <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-370">
          📚 LOS 6 TOMOS - TRAMO 2 EBI
        </h2>
        <p className="text-lg text-stone-600 font-medium" data-id="element-371">
          Cada tomo está diseñado para cubrir una unidad curricular completa con
          progresión pedagógica.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-372">
        {tomos.map((tomo, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: idx * 0.1
      }} className={`rounded-2xl p-6 md:p-8 border shadow-sm flex flex-col h-full ${tomo.color} bg-opacity-50`} data-id="element-373">
            <div className="text-4xl mb-4" data-id="element-374">{tomo.icon}</div>
            <h3 className="text-xl font-bold mb-1" data-id="element-375">{tomo.title}</h3>
            <div className="text-sm font-bold opacity-75 uppercase tracking-wider mb-4" data-id="element-376">
              {tomo.subtitle}
            </div>
            <p className="font-medium opacity-90 leading-relaxed mt-auto" data-id="element-377">
              {tomo.desc}
            </p>
          </motion.div>)}
      </div>
    </Section>;
};